import { LeagueConfig } from '@leagueplatform/config';
import { AppTenant } from 'types';
import {
  highmarkCommonCoreConfig,
  highmarkConfigFlags,
} from './highmark-theme/config/highmark-common-config';
import { ASSETS_CONFIG } from './highmark-theme/config/beneficity-asset-config';

const {
  VITE_BENEFICITY_CONTENT_URL,
  VITE_BENEFICITY_AUTH0_DOMAIN,
  VITE_BENEFICITY_AUTH0_CLIENT_ID,
} = import.meta.env;

export const highmarkBeneficity = {
  core: {
    ...highmarkCommonCoreConfig,
    tenantId: AppTenant.HighmarkBeneficity,
    clientId: `${AppTenant.HighmarkBeneficity}-web`,
    contentUrl: VITE_BENEFICITY_CONTENT_URL,
    auth: {
      clientOptions: {
        domain: VITE_BENEFICITY_AUTH0_DOMAIN,
        client_id: VITE_BENEFICITY_AUTH0_CLIENT_ID,
        redirect_uri: window.location.origin,
        connection: 'highmark-internal-enterprise-saml',
      },
      idleSessionLifetimeHours: 0.25,
    },
  },
  assets: {
    overrides: ASSETS_CONFIG,
  },
  ...highmarkConfigFlags,
} satisfies LeagueConfig;
